import type { NextPage, GetServerSidePropsContext } from 'next'

// import { getAllFacilities } from '@/api/facilities'
import { FacilitiesList } from '@/features/facilities/FacilitiesList'
import SeoHead from '@/components/seo-head'
import { useTranslations } from 'next-intl'
// import { initializeApollo, addApolloState } from '@/utils/apolloClient'

const FacilitiesPage: NextPage = () => {
  const t = useTranslations()

  return (
    <>
      <SeoHead
        title={t('facilities-list.seo.title')}
        breadcrumbTitle={t('facilities-list.seo.breadcrumb')}
        description={t('facilities-list.seo.description')}
      />
      <FacilitiesList />
    </>
  )
}

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  // const apolloClient = initializeApollo()
  // const { data } = await apolloClient.query({
  //   query: getAllFacilities,
  // })

  // if (!data) {
  //   return addApolloState(apolloClient, {
  //     notFound: true,
  //   })
  // }

  // return addApolloState(apolloClient, {
  return {
    props: {
      messages: (await import(`../../../locales/${locale}.json`)).default,
    },
  }
}

export default FacilitiesPage
